import { InfoCircleFilled } from '@ant-design/icons';
import * as React from 'react';

export const AUIInfoCircleFilled = () => (
  <InfoCircleFilled style={{ color: '#3996E0' }} />
  );
